// Mantún (13-10-2026, copia del arreglo de FunFungi): la barra fija de compra (sticky-atc de Shrine) muestra el precio de la opción elegida en Kaching,
// más lo agregado con su casilla (si la oferta trae agregados), con el precio tachado si hay descuento.
// Antes mostraba siempre el precio de 1 unidad aunque el botón agregara la opción elegida.
// Sin Kaching en la página, la barra queda como siempre. Se carga desde snippets/mt-tienda.liquid en las fichas.
(function () {
  if (window.mtBarraPrecio) return;
  window.mtBarraPrecio = true;

  function numero(el) {
    return el ? parseInt(el.textContent.replace(/\D/g, ''), 10) || 0 : 0;
  }
  function plata(n) {
    return '$' + n.toLocaleString('es-CL');
  }
  // Escribir solo si cambia: el observador mira la misma sección y no debe entrar en bucle
  function poner(el, texto) {
    if (el.textContent !== texto) el.textContent = texto;
  }

  function seccion() {
    var barra = document.querySelector('sticky-atc[data-section]');
    return (barra && document.getElementById('shopify-section-' + barra.dataset.section)) || document;
  }

  function calcular(raiz) {
    var opcion = raiz.querySelector('.kaching-bundles__bar--selected') || document.querySelector('.kaching-bundles__bar--selected');
    if (!opcion) return null;
    var precio = numero(opcion.querySelector('.kaching-bundles__bar-price'));
    if (!precio) return null;
    var antes = numero(opcion.querySelector('.kaching-bundles__bar-full-price')) || precio;
    opcion.querySelectorAll('.kaching-bundles__upsell').forEach(function (u) {
      if (!u.querySelector('.kaching-bundles__upsell__checkbox--selected')) return;
      var p = numero(u.querySelector('.kaching-bundles__upsell__price'));
      precio += p;
      antes += numero(u.querySelector('.kaching-bundles__upsell__full-price')) || p;
    });
    return { precio: precio, antes: antes };
  }

  function pintar() {
    var r = calcular(seccion());
    if (!r) return;
    var enOferta = r.antes > r.precio;
    document.querySelectorAll('.sticky-atc .price').forEach(function (cont) {
      if (cont.classList.contains('price--on-sale') !== enOferta) cont.classList.toggle('price--on-sale', enOferta);
      cont.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (e) {
        poner(e, plata(r.precio));
      });
      cont.querySelectorAll('.price__sale .price__compare-price s').forEach(function (e) {
        poner(e, enOferta ? plata(r.antes) : '');
      });
      cont.querySelectorAll('.badge__percentage-saved').forEach(function (e) {
        poner(e, enOferta ? String(Math.round(((r.antes - r.precio) * 100) / r.antes)) : '');
      });
    });
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      pintar();
    });
  }

  function iniciar() {
    if (!document.querySelector('.sticky-atc .price')) return;
    var raiz = seccion();
    // Kaching dibuja sus opciones unos segundos después y las vuelve a dibujar al elegir: mirar la sección entera
    new MutationObserver(programar).observe(raiz === document ? document.body : raiz, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    programar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

// 13-10-2026 (pedido de Mau, igual que FunFungi): en celular el botón flotante de WhatsApp (#mantun-whatsapp-float)
// tapa el precio de las opciones de Kaching. Se esconde mientras el bloque de compra (opciones de Kaching + botón)
// está en pantalla y vuelve al bajar a la descripción. El bloque es el contenedor común de Kaching y del formulario.
(function () {
  if (window.mtWaCompra || !('IntersectionObserver' in window)) return;
  window.mtWaCompra = true;

  function iniciar() {
    var form = document.querySelector('product-form.main-product-form');
    var bloque = form && form.parentElement;
    if (!bloque) return;
    var estilo = document.createElement('style');
    estilo.textContent = '@media screen and (max-width: 899px) { body.mt-compra-en-vista #mantun-whatsapp-float { display: none !important; } }';
    document.head.appendChild(estilo);
    new IntersectionObserver(function (es) {
      document.body.classList.toggle('mt-compra-en-vista', es[0].isIntersecting);
    }).observe(bloque);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
